<div class="input_checkbox" *ngIf="showDatenschutzPolicy">
  <mat-checkbox [formControl]="datenschutzPolicy">
    <ng-container *ngIf="produktArt !== 3">
    Ich habe die <a [href]="productLinkInfo" class="textLink" target="blank">Produkt- und Vertriebsinformationen</a> gelesen. *
    </ng-container>
    <ng-container *ngIf="produktArt === 3">
      Ich habe die Produkt- und Vertriebsinformationen für die <a [href]="translateService.get('LINKPRODUCTINFOHAUSHALT') | async" class="textLink" target="blank">Haushalts-</a> und <a [href]="translateService.get('LINKPRODUCTINFOEIGENHEIM') | async" class="textLink" target="blank">Eigenheimversicherung</a> gelesen. *
    </ng-container>
  </mat-checkbox>
  <mat-error *ngIf="datenschutzPolicy.hasError('required') && (datenschutzPolicy.touched || parentFormGroupDirective.submitted)">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
</div>
